import track from 'react-tracking';
import DataTable from '@components/DataTable';
import ViewedCompaniesItem from './ViewedCompaniesItem/ViewedCompaniesItem';

interface ViewedCompaniesItemType {
  name: string;
  expiryTime: string;
  uniqueSymbol: string;
  canonicalUrl: string;
}

interface Props {
  list: ViewedCompaniesItemType[];
  handleClick?: () => void;
  light?: boolean;
}

const ViewedCompanies = ({ list, light, handleClick }: Props) => (
  <DataTable columnWidths="5,4,1" light={light}>
    <thead>
      <tr>
        <th>Company</th>
        <th>Spot available</th>
        <th />
      </tr>
    </thead>
    <tbody>
      {list.length <= 0 && (
        <tr>
          <td colSpan={3}>You haven't viewed companies yet</td>
        </tr>
      )}
      {list.map((n, i) => (
        <ViewedCompaniesItem
          key={`ViewedCompaniesItem-${n.uniqueSymbol}`}
          index={i}
          name={n.name}
          uniqueSymbol={n.uniqueSymbol}
          handleClick={handleClick}
          canonicalUrl={n.canonicalUrl}
          expiryTime={n.expiryTime}
        />
      ))}
    </tbody>
  </DataTable>
);

export default track(({ list }) => ({
  type: 'track',
  listLength: list.length,
}))(ViewedCompanies);
